"use strict";

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
document.addEventListener("DOMContentLoaded", function (e) {
  navigationInit();
  effectsInit();
  checkScroll();
  inlineSvgs();
});

function navigationInit() {
  var mainMenu = document.querySelector(".main-navigation");
  if (!mainMenu) return;
  var menuToggle = mainMenu.querySelector(".menu-toggle");
  var linksWithChildren = mainMenu.querySelectorAll(".menu-item-has-children");
  menuToggle.addEventListener("click", function (e) {
    document.body.classList.toggle("menu-toggled");

    if (menuToggle.getAttribute("aria-expanded") === "false") {
      menuToggle.setAttribute("aria-expanded", true);
    } else {
      menuToggle.setAttribute("aria-expanded", false);
    }
  });
  linksWithChildren.forEach(function (link, i) {
    // console.log(link);
    var dropDown = document.createElement("button");
    dropDown.className = "dropdown-toggle";
    dropDown.addEventListener("click", function (e) {
      link.classList.toggle("active");
    });
    link.prepend(dropDown);
  });
}

function checkScroll() {
  var siteHeader = document.querySelector('.site-header');
  window.addEventListener('scroll', function (e) {
    // console.log(window.scrollY);
    if (window.scrollY > siteHeader.clientHeight) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  });
}

function effectsInit() {
  document.querySelectorAll('.entry-content :where(h1,h2,h3,h4,h5,h6,ul,ol,p)').forEach(function (el, i) {
    gsap.from(el, {
      opacity: 0,
      y: 20,
      scrollTrigger: {
        trigger: el
      }
    });
  });
  document.querySelectorAll('.wp-block-media-text__media img, .post-thumbnail img').forEach(function (el, i) {
    gsap.from(el, {
      // opacity: 0,
      // scale: .8,
      clipPath: 'inset(50% 0)',
      // stagger: .2,
      scrollTrigger: {
        trigger: el
      }
    });
  }); // Sticky Buttons

  var footerButtons = document.querySelector('.footer-buttons');
  var contactRow = document.querySelector('.contact-row');
  gsap.set(contactRow, {
    marginTop: footerButtons.clientHeight * 2.5
  });
  gsap.set(footerButtons, {
    position: 'absolute'
  });
  document.body.prepend(footerButtons);
  gsap.from(footerButtons, {
    scrollTrigger: {
      trigger: footerButtons,
      start: "top 100%-=".concat(footerButtons.clientHeight * 2),
      end: function end() {
        return document.body.clientHeight - window.innerHeight - contactRow.clientHeight;
      },
      pin: true,
      pinSpacing: false
    }
  });
}

function inlineSvgs() {
  document.querySelectorAll('.custom-logo[src*=".svg"]').forEach(function (el) {
    fetchSvgInline(el);
  });
}

function fetchSvgInline(image) {
  fetch(image.currentSrc || image.src).then(function (response) {
    return response.text();
  }).then(function (response) {
    var svgStr = response;

    if (svgStr.indexOf('<svg') === -1) {
      return;
    }

    var span = document.createElement('span');
    span.innerHTML = svgStr;
    var inlineSvg = span.querySelector('svg');
    inlineSvg.setAttribute('aria-label', image.alt || '');
    inlineSvg.setAttribute('class', image.className); // IE doesn't support classList on SVGs

    inlineSvg.setAttribute('focusable', false);
    inlineSvg.setAttribute('role', 'img');

    if (image.height) {
      inlineSvg.setAttribute('height', image.height);
    }

    if (image.width) {
      inlineSvg.setAttribute('width', image.width);
    }

    image.parentNode.replaceChild(inlineSvg, image);
  }).catch(function () {
    image.classList.add('not-inline');
  });
}

;